import React from 'react';

class SchemeItem extends React.Component {
  handleClick = () => {
    if (this.props.available) {
      const { redux } = this.props,
        { data } = this.props;
      redux.addItemToInventoryAction({
        name: data.name,
        value: data.result,
        weight: data.result * data.weight,
        baseWeight: data.weight,
        basePrice: data.price,
      });
      redux.updateWeightAction(data.result * data.weight);
      data.items.map((item) => {
        redux.removeItemFromInventoryAction({
          name: item.name,
          value: item.amount,
          weight: redux.inventory[item.name].baseWeight * item.amount,
        });
        redux.updateWeightAction(
          -redux.inventory[item.name].baseWeight * item.amount
        );
        return true;
      });
    }
  };
  render() {
    const { data } = this.props;
    return (
      <div
        className={this.props.available ? 'scheme' : 'scheme disabled'}
        onClick={this.handleClick}
      >
        <p className="scheme-name">
          {data.name} ({data.result})
        </p>
        <div className="scheme-items">
          {data.items.map(function (item, index) {
            return (
              <React.Fragment key={index}>
                <p>
                  {item.name} ({item.amount})
                </p>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }
}

export { SchemeItem };
